import type { RelationType } from '@arianna/shared'

/**
 * Famiglia di relazione: raggruppa i 7 `relationType` in 3 famiglie visive
 * (§ Definitions del task). Usata da layout, visibilità, filtro e fuoco.
 */
export type RelationFamily = 'structure' | 'dynamic' | 'contrast'

export const RELATION_FAMILY: Record<RelationType, RelationFamily> = {
  'is-a': 'structure',
  'part-of': 'structure',
  'defined-by': 'structure',
  exemplifies: 'structure',
  causes: 'dynamic',
  'prerequisite-of': 'dynamic',
  opposes: 'contrast',
}

/** `null` per tipi sconosciuti (il client mobile allenta `relationType` a stringa). */
export function relationFamily(type: string): RelationFamily | null {
  return (RELATION_FAMILY as Record<string, RelationFamily | undefined>)[type] ?? null
}

export type MapLocale = 'it' | 'en'

const VERB_IT: Record<RelationType, string> = {
  'is-a': 'è un',
  'part-of': 'parte di',
  'defined-by': 'definisce',
  exemplifies: 'esempio di',
  causes: 'causa',
  'prerequisite-of': 'prima di',
  opposes: 'contro',
}

const VERB_EN: Record<RelationType, string> = {
  'is-a': 'is a',
  'part-of': 'part of',
  'defined-by': 'defines',
  exemplifies: 'example of',
  causes: 'causes',
  'prerequisite-of': 'before',
  opposes: 'against',
}

const PHRASE_IT: Record<RelationType, string> = {
  'is-a': 'è un tipo di',
  'part-of': 'è parte di',
  'defined-by': 'si definisce con',
  exemplifies: 'è un esempio di',
  causes: 'causa',
  'prerequisite-of': 'è prerequisito di',
  opposes: 'si oppone a',
}

const PHRASE_EN: Record<RelationType, string> = {
  'is-a': 'is a kind of',
  'part-of': 'is part of',
  'defined-by': 'is defined by',
  exemplifies: 'is an example of',
  causes: 'causes',
  'prerequisite-of': 'is a prerequisite of',
  opposes: 'opposes',
}

/** Tipo sconosciuto → il tipo grezzo. */
export function relationVerb(type: string, locale: MapLocale): string {
  const dict = locale === 'it' ? VERB_IT : VERB_EN
  return (dict as Record<string, string | undefined>)[type] ?? type
}

/** Tipo sconosciuto → il tipo grezzo. */
export function relationPhrase(type: string, locale: MapLocale): string {
  const dict = locale === 'it' ? PHRASE_IT : PHRASE_EN
  return (dict as Record<string, string | undefined>)[type] ?? type
}
